import { isSafari } from "@helpers/fullScreenHelper";
import ReactPlayer from "react-player";
import { useAppSelector } from "../../app/hooks";
import { BasicProps } from "./ComponentsInterface";
import styles from "./VideoPlayer.module.css";

const VideoPlayer = ({ url, children, onLoadError, onEnd, onProgress, onDuration }: VideoPlayerProps): JSX.Element => {
    const disableVideos = useAppSelector((x) => x.globalSettings.disableVideos);

    const urlOverride = !disableVideos ? url : url + "xxx";

    const autoplay = !isSafari;

    return (
        <div className={`${styles.container} m-auto is-flex is-justify-content-center`}>
            <div className={styles.videoContainer}>
                {children}
                <ReactPlayer
                    url={urlOverride}
                    width={"100%"}
                    height={"100%"}
                    onProgress={onProgress}
                    onDuration={onDuration}
                    onError={(err) => {
                        // code for chrome autoplay
                        if (err.message?.includes("xX8pDD")) return;
                        onLoadError?.();
                    }}
                    onEnded={onEnd}
                    controls={true}
                    playing={autoplay}
                    config={{
                        vimeo: {
                            playerOptions: {
                                texttrack: "en",
                                controls: true, // we shold disable this on a prod environment
                                responsive: true,
                                keyboard: false,
                                autoplay
                            }
                        }
                    }}
                />
            </div>
        </div>
    );
};

export default VideoPlayer;

interface VideoPlayerProps extends BasicProps {
    url: string;
    onLoadError?: () => void;
    onEnd?: () => void;
    onDuration?: (videoLength: number) => void;
    onProgress?: (progress: any) => void;
}
